import { observable } from 'mobx'
import { ISODocumentRequest } from '../../../requests/ISODocumentRequest'
import isoDocumentStore from '../isoDocumentStore'
import { message } from 'antd'

class CreateISOFolderStore {
  @observable isLoading = false

  create = async (newFolderName, parentFolderId) => {
    try {
      this.isLoading = true

      await ISODocumentRequest.createFolder(newFolderName, parentFolderId)

      await isoDocumentStore.getItems()
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      this.isLoading = false
    }
  }

  clearStore = () => {
    this.isLoading = false
  }
}

export default new CreateISOFolderStore()
